import type { Movie } from "@/types/movie";

export const movies: Movie[] = [
  {
    id: "1001",
    title: "星海拾光",
    category: "movie",
    genres: ["科幻", "剧情"],
    year: 2024,
    region: "中国大陆",
    rating: 8.9,
    popularity: 982000,
    director: "陆知远",
    actors: ["陈屿", "林晚晴", "周牧"],
    summary:
      "一名深空信号工程师在废弃的空间站里收到三十年前发出的求救讯号，为了找到讯号的来源，他孤身穿越星海，也在旅途中重新面对自己失去的家人与记忆。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20movie%20poster%20of%20a%20lone%20astronaut%20silhouette%20before%20a%20glowing%20red%20and%20gold%20nebula%2C%20deep%20space%2C%20volumetric%20lighting%2C%20minimalist%20dark%20background%2C%20high%20detail%2C%20consistent%20editorial%20poster%20style&width=600&height=900&seq=rhtv-poster-1001&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Epic%20widescreen%20sci-fi%20scene%20of%20a%20vast%20red%20nebula%20with%20a%20tiny%20spacecraft%2C%20dramatic%20space%20cinematography%2C%20deep%20crimson%20and%20amber%20tones%2C%20dark%20atmospheric%20mood%2C%20high%20detail&width=1600&height=900&seq=rhtv-backdrop-1001&orientation=landscape",
    featured: true,
    createdAt: "2024-09-12",
  },
  {
    id: "1002",
    title: "雾都谜案",
    category: "movie",
    genres: ["悬疑", "犯罪"],
    year: 2024,
    region: "中国香港",
    rating: 8.6,
    popularity: 875000,
    director: "何叙白",
    actors: ["阮清和", "骆成", "苏宛"],
    summary:
      "民国时期的雾都接连发生离奇失踪案，落魄侦探与报社女记者联手调查，却发现每一条线索都指向二十年前的一桩旧案，真相远比浓雾更加难以看清。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20mystery%20thriller%20movie%20poster%20of%20a%20man%20in%20a%20long%20coat%20walking%20through%20a%20foggy%20vintage%20city%20street%20with%20a%20lantern%2C%20noir%20red%20and%20charcoal%20tones%2C%20moody%20lighting%2C%20high%20detail&width=600&height=900&seq=rhtv-poster-1002&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Atmospheric%20widescreen%20noir%20city%20in%20thick%20fog%20at%20night%20with%20warm%20red%20streetlamps%2C%20cinematic%20mystery%20mood%2C%20dark%20charcoal%20and%20crimson%20tones%2C%20high%20detail&width=1600&height=900&seq=rhtv-backdrop-1002&orientation=landscape",
    featured: true,
    createdAt: "2024-08-30",
  },
  {
    id: "1003",
    title: "山河故人归",
    category: "movie",
    genres: ["剧情", "家庭"],
    year: 2023,
    region: "中国大陆",
    rating: 9.1,
    popularity: 654000,
    director: "许南舟",
    actors: ["沈亦舟", "柳素心", "傅恒"],
    summary:
      "一位在外漂泊多年的建筑师回到故乡小镇，为老宅做最后的测绘，却在旧物与旧人之间，找回了被时间冲淡的亲情与承诺。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20drama%20movie%20poster%20of%20a%20person%20standing%20before%20an%20ancient%20Chinese%20courtyard%20at%20golden%20sunset%2C%20warm%20amber%20and%20deep%20red%20tones%2C%20nostalgic%20mood%2C%20minimalist%20composition%2C%20high%20detail&width=600&height=900&seq=rhtv-poster-1003&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Widescreen%20golden%20hour%20view%20of%20misty%20mountains%20and%20a%20traditional%20Chinese%20village%2C%20warm%20amber%20and%20crimson%20tones%2C%20cinematic%20emotional%20mood%2C%20high%20detail&width=1600&height=900&seq=rhtv-backdrop-1003&orientation=landscape",
    featured: true,
    createdAt: "2023-11-05",
  },
  {
    id: "1004",
    title: "深海回声",
    category: "movie",
    genres: ["科幻", "悬疑"],
    year: 2024,
    region: "美国",
    rating: 8.3,
    popularity: 763000,
    director: "Ethan Marlowe",
    actors: ["Alan Reed", "Nora Vale", "Kate Sun"],
    summary:
      "深海科考队在万米海沟捕捉到一段规律的机械回声，随着潜水器不断下潜，队员们逐渐意识到，他们追踪的可能并非自然现象。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20underwater%20sci-fi%20movie%20poster%20of%20a%20diving%20submersible%20glowing%20in%20the%20deep%20dark%20ocean%2C%20teal%20and%20crimson%20accents%2C%20eerie%20lighting%2C%20minimalist%20composition%2C%20high%20detail&width=600&height=900&seq=rhtv-poster-1004&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Widescreen%20deep%20ocean%20trench%20with%20a%20bright%20submersible%20light%20beam%20in%20the%20dark%20water%2C%20mysterious%20cinematic%20mood%2C%20deep%20blue%20and%20red%20glow%2C%20high%20detail&width=1600&height=900&seq=rhtv-backdrop-1004&orientation=landscape",
    featured: true,
    createdAt: "2024-07-18",
  },
  {
    id: "1005",
    title: "烈焰行动",
    category: "movie",
    genres: ["动作", "犯罪"],
    year: 2024,
    region: "中国大陆",
    rating: 8.0,
    popularity: 812000,
    director: "秦烈",
    actors: ["龙震", "白露", "韩霄"],
    summary:
      "一场突如其来的城市危机将退役特警与年轻刑警绑在了同一条战线上，他们必须在七十二小时内阻止一场精心策划的阴谋。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20action%20movie%20poster%20of%20a%20silhouetted%20figure%20standing%20in%20a%20burning%20urban%20street%20with%20orange%20sparks%2C%20dramatic%20red%20and%20black%20tones%2C%20high%20contrast%2C%20minimalist%20composition%2C%20high%20detail&width=600&height=900&seq=rhtv-poster-1005&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Widescreen%20dramatic%20city%20skyline%20at%20night%20with%20glowing%20fire%20sparks%20and%20red%20emergency%20lights%2C%20cinematic%20action%20mood%2C%20dark%20tones%2C%20high%20detail&width=1600&height=900&seq=rhtv-backdrop-1005&orientation=landscape",
    featured: false,
    createdAt: "2024-10-02",
  },
  {
    id: "1006",
    title: "春日迟迟",
    category: "movie",
    genres: ["爱情", "剧情"],
    year: 2023,
    region: "日本",
    rating: 8.4,
    popularity: 540000,
    director: "佐藤凌",
    actors: ["森川遥", "白石真", "松本澈"],
    summary:
      "在樱花将谢的春天，一位书店店主与来寄卖旧书的女子相识，两个都在逃避过去的人，慢慢在季节更替里学会了告别。",
    poster:
      "https://readdy.ai/api/search-image?query=Soft%20cinematic%20romance%20movie%20poster%20of%20cherry%20blossoms%20falling%20over%20a%20quiet%20bookshop%20window%2C%20warm%20rose%20and%20cream%20tones%2C%20gentle%20lighting%2C%20minimalist%20composition%2C%20high%20detail&width=600&height=900&seq=rhtv-poster-1006&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Widescreen%20spring%20scene%20of%20a%20cherry%20blossom%20avenue%20in%20soft%20afternoon%20light%2C%20warm%20rosy%20and%20cream%20tones%2C%20romantic%20cinematic%20mood%2C%20high%20detail&width=1600&height=900&seq=rhtv-backdrop-1006&orientation=landscape",
    featured: false,
    createdAt: "2023-04-20",
  },
  {
    id: "1007",
    title: "时间之外",
    category: "movie",
    genres: ["科幻", "剧情"],
    year: 2022,
    region: "英国",
    rating: 8.8,
    popularity: 601000,
    director: "Olivia Grant",
    actors: ["Henry Cole", "Mia Hart", "Leo Nash"],
    summary:
      "一名古董钟表匠发现修理过的座钟能让时间倒流五分钟，他用这五分钟一次次挽回遗憾，却逐渐发现代价正悄然累积。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20time-travel%20drama%20poster%20of%20an%20antique%20clock%20face%20glowing%20in%20a%20dim%20workshop%20with%20floating%20gears%2C%20gold%20and%20deep%20red%20tones%2C%20moody%20lighting%2C%20high%20detail&width=600&height=900&seq=rhtv-poster-1007&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Widescreen%20mysterious%20workshop%20filled%20with%20glowing%20antique%20clocks%20and%20floating%20golden%20gears%2C%20cinematic%20moody%20lighting%2C%20deep%20red%20and%20gold%20tones%2C%20high%20detail&width=1600&height=900&seq=rhtv-backdrop-1007&orientation=landscape",
    featured: false,
    createdAt: "2022-12-16",
  },
  {
    id: "1008",
    title: "无为而治",
    category: "movie",
    genres: ["喜剧"],
    year: 2023,
    region: "中国大陆",
    rating: 7.7,
    popularity: 690000,
    director: "高鹤",
    actors: ["赵拾", "马小满", "杜诚"],
    summary:
      "一位被公司裁员的中年男人阴差阳错当上了社区物业主任，从此在鸡毛蒜皮的邻里琐事里，上演了一连串令人捧腹的乌龙事件。",
    poster:
      "https://readdy.ai/api/search-image?query=Playful%20comedy%20movie%20poster%20of%20a%20confused%20man%20holding%20a%20mop%20in%20a%20colorful%20residential%20courtyard%2C%20warm%20red%20and%20cream%20tones%2C%20bright%20cheerful%20lighting%2C%20minimalist%20composition%2C%20high%20detail&width=600&height=900&seq=rhtv-poster-1008&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Widescreen%20bright%20cheerful%20residential%20courtyard%20scene%20in%20daylight%2C%20warm%20colorful%20tones%2C%20comedic%20cinematic%20mood%2C%20high%20detail&width=1600&height=900&seq=rhtv-backdrop-1008&orientation=landscape",
    featured: false,
    createdAt: "2023-06-24",
  },
  {
    id: "1009",
    title: "追风少年",
    category: "movie",
    genres: ["剧情", "青春"],
    year: 2024,
    region: "中国大陆",
    rating: 8.2,
    popularity: 578000,
    director: "田野",
    actors: ["许云帆", "毛豆", "郑一鸣"],
    summary:
      "来自小城的三名少年为了一个全国自行车赛的名额组建车队，在汗水与质疑中，他们学会了比输赢更重要的东西。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20youth%20sports%20movie%20poster%20of%20three%20young%20cyclists%20racing%20at%20sunrise%20along%20a%20coastal%20road%2C%20warm%20orange%20and%20red%20tones%2C%20energetic%20lighting%2C%20high%20detail&width=600&height=900&seq=rhtv-poster-1009&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Widescreen%20sunrise%20coastal%20road%20with%20a%20group%20of%20cyclists%20riding%20toward%20the%20light%2C%20warm%20orange%20and%20crimson%20tones%2C%20inspiring%20cinematic%20mood%2C%20high%20detail&width=1600&height=900&seq=rhtv-backdrop-1009&orientation=landscape",
    featured: false,
    createdAt: "2024-05-11",
  },
  {
    id: "1010",
    title: "归途列车",
    category: "movie",
    genres: ["剧情"],
    year: 2023,
    region: "韩国",
    rating: 8.5,
    popularity: 493000,
    director: "朴允浩",
    actors: ["金叙俊", "韩智雅", "李道允"],
    summary:
      "除夕夜的一趟末班列车上，素不相识的乘客因为一场暴雪滞留，被迫共度一夜，各自的人生故事在这节车厢里悄然交汇。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20drama%20movie%20poster%20of%20a%20warmly%20lit%20night%20train%20window%20with%20snow%20outside%2C%20cozy%20amber%20and%20red%20tones%2C%20nostalgic%20mood%2C%20minimalist%20composition%2C%20high%20detail&width=600&height=900&seq=rhtv-poster-1010&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Widescreen%20snowy%20night%20scene%20of%20a%20train%20traveling%20through%20a%20quiet%20countryside%2C%20warm%20window%20glow%2C%20cinematic%20emotional%20mood%2C%20deep%20red%20and%20amber%20tones%2C%20high%20detail&width=1600&height=900&seq=rhtv-backdrop-1010&orientation=landscape",
    featured: false,
    createdAt: "2023-12-28",
  },
  {
    id: "1011",
    title: "无声告白",
    category: "movie",
    genres: ["悬疑", "剧情"],
    year: 2024,
    region: "中国大陆",
    rating: 8.7,
    popularity: 708000,
    director: "龚晚",
    actors: ["沈书言", "白砚", "温子墨"],
    summary:
      "一位聋哑少女意外成为一桩校园事件的唯一目击者，为了说出真相，她用图画与文字展开了一场无声却震撼人心的抗争。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20emotional%20movie%20poster%20of%20a%20young%20woman%20holding%20a%20sketchbook%20in%20soft%20window%20light%2C%20deep%20red%20and%20charcoal%20tones%2C%20quiet%20melancholic%20mood%2C%20minimalist%20composition%2C%20high%20detail&width=600&height=900&seq=rhtv-poster-1011&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Widescreen%20quiet%20school%20corridor%20with%20soft%20light%20through%20tall%20windows%2C%20cinematic%20melancholic%20mood%2C%20deep%20red%20and%20grey%20tones%2C%20high%20detail&width=1600&height=900&seq=rhtv-backdrop-1011&orientation=landscape",
    featured: false,
    createdAt: "2024-09-27",
  },
  {
    id: "1012",
    title: "银翼黄昏",
    category: "movie",
    genres: ["科幻", "动作"],
    year: 2022,
    region: "美国",
    rating: 8.1,
    popularity: 745000,
    director: "Marcus Bell",
    actors: ["Ryan Fox", "Elena Cruz", "Sam Ito"],
    summary:
      "在被巨型企业统治的未来都市，一名老旧的仿生警察追查一桩连环命案，却在调查中开始怀疑自己记忆的真实性。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20cyberpunk%20sci-fi%20movie%20poster%20of%20a%20lone%20figure%20in%20a%20rainy%20neon%20city%20at%20dusk%2C%20red%20and%20amber%20neon%20tones%2C%20moody%20lighting%2C%20minimalist%20composition%2C%20high%20detail&width=600&height=900&seq=rhtv-poster-1012&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Widescreen%20futuristic%20rainy%20city%20skyline%20glowing%20with%20red%20and%20amber%20neon%2C%20cinematic%20cyberpunk%20mood%2C%20dark%20atmospheric%20tones%2C%20high%20detail&width=1600&height=900&seq=rhtv-backdrop-1012&orientation=landscape",
    featured: false,
    createdAt: "2022-10-08",
  },
  {
    id: "1013",
    title: "城南旧事录",
    category: "movie",
    genres: ["剧情", "家庭"],
    year: 2021,
    region: "中国大陆",
    rating: 8.6,
    popularity: 432000,
    director: "吴榭",
    actors: ["朱怀安", "陈美娟", "小满"],
    summary:
      "以一座南方老城为背景，讲述三代人守着同一间老茶馆的故事，在时代变迁中，他们用一杯茶留住了一座城的温度。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20period%20drama%20movie%20poster%20of%20a%20traditional%20Chinese%20teahouse%20with%20steam%20rising%20in%20warm%20light%2C%20amber%20and%20deep%20red%20tones%2C%20nostalgic%20mood%2C%20high%20detail&width=600&height=900&seq=rhtv-poster-1013&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Widescreen%20old%20southern%20Chinese%20street%20at%20dusk%20with%20warm%20lantern%20glow%2C%20cinematic%20nostalgic%20mood%2C%20deep%20red%20and%20amber%20tones%2C%20high%20detail&width=1600&height=900&seq=rhtv-backdrop-1013&orientation=landscape",
    featured: false,
    createdAt: "2021-09-15",
  },
  {
    id: "1014",
    title: "云端之上",
    category: "movie",
    genres: ["剧情", "爱情"],
    year: 2024,
    region: "法国",
    rating: 8.0,
    popularity: 388000,
    director: "Claire Dubois",
    actors: ["Julien Roy", "Emma Blanc", "Noah Petit"],
    summary:
      "一名热气球飞行员与一位恐高的插画师约定，用一次飞行交换彼此心底最深的秘密，在云端之上，他们重新学会了信任。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20romance%20movie%20poster%20of%20a%20hot%20air%20balloon%20floating%20over%20misty%20hills%20at%20sunrise%2C%20warm%20rose%20and%20red%20tones%2C%20dreamy%20lighting%2C%20minimalist%20composition%2C%20high%20detail&width=600&height=900&seq=rhtv-poster-1014&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Widescreen%20hot%20air%20balloons%20floating%20over%20misty%20green%20hills%20at%20sunrise%2C%20warm%20rosy%20and%20crimson%20tones%2C%20romantic%20cinematic%20mood%2C%20high%20detail&width=1600&height=900&seq=rhtv-backdrop-1014&orientation=landscape",
    featured: false,
    createdAt: "2024-03-22",
  },
  {
    id: "2001",
    title: "长夜将明",
    category: "tv",
    genres: ["悬疑", "犯罪"],
    year: 2024,
    region: "中国大陆",
    rating: 9.0,
    popularity: 1250000,
    director: "顾长夜",
    actors: ["谢知遥", "蓝屿", "蒋泓"],
    summary:
      "一所重点高中接连发生学生失踪事件，年轻的心理老师与执拗的老刑警联手追查，层层剥开之下，是一段被刻意掩埋的往事。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20mystery%20series%20poster%20of%20a%20street%20lamp%20glowing%20in%20a%20dark%20empty%20schoolyard%20at%20night%2C%20deep%20red%20and%20charcoal%20tones%2C%20tense%20mood%2C%20minimalist%20composition%2C%20high%20detail&width=600&height=900&seq=rhtv-poster-2001&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Widescreen%20dark%20empty%20school%20corridor%20at%20night%20with%20a%20single%20red%20light%20glow%2C%20cinematic%20suspense%20mood%2C%20deep%20charcoal%20and%20crimson%20tones%2C%20high%20detail&width=1600&height=900&seq=rhtv-backdrop-2001&orientation=landscape",
    featured: true,
    createdAt: "2024-09-01",
  },
  {
    id: "2002",
    title: "繁花里巷",
    category: "tv",
    genres: ["都市", "爱情"],
    year: 2024,
    region: "中国大陆",
    rating: 8.5,
    popularity: 1120000,
    director: "林蔚",
    actors: ["苏念", "陆则言", "温雅"],
    summary:
      "上海老弄堂里，一群年轻人经营着一家即将拆迁的咖啡馆，在城市的更新浪潮中，他们守护的不只是一家店，还有彼此的梦想。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20urban%20series%20poster%20of%20a%20cozy%20cafe%20with%20warm%20lights%20on%20a%20lively%20city%20alley%2C%20warm%20red%20and%20cream%20tones%2C%20cheerful%20mood%2C%20high%20detail&width=600&height=900&seq=rhtv-poster-2002&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Widescreen%20lively%20modern%20city%20alley%20with%20warm%20shop%20lights%20at%20dusk%2C%20cheerful%20cinematic%20mood%2C%20warm%20red%20and%20amber%20tones%2C%20high%20detail&width=1600&height=900&seq=rhtv-backdrop-2002&orientation=landscape",
    featured: false,
    createdAt: "2024-06-14",
  },
  {
    id: "2003",
    title: "山海有约",
    category: "tv",
    genres: ["古装", "奇幻"],
    year: 2023,
    region: "中国大陆",
    rating: 8.8,
    popularity: 1340000,
    director: "姜疏影",
    actors: ["云舒", "墨莲", "子规"],
    summary:
      "传说上古神兽守护着人间与山海之界的平衡，一位背负宿命的少女与一位失忆的守界人相遇，共同踏上了重启封印的旅程。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20fantasy%20series%20poster%20of%20a%20figure%20in%20flowing%20robes%20before%20misty%20ancient%20mountains%20with%20a%20glowing%20totem%2C%20deep%20red%20and%20gold%20tones%2C%20epic%20mood%2C%20high%20detail&width=600&height=900&seq=rhtv-poster-2003&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Widescreen%20epic%20ancient%20Chinese%20mountain%20range%20above%20a%20sea%20of%20clouds%20with%20golden%20light%2C%20cinematic%20fantasy%20mood%2C%20deep%20red%20and%20amber%20tones%2C%20high%20detail&width=1600&height=900&seq=rhtv-backdrop-2003&orientation=landscape",
    featured: false,
    createdAt: "2023-07-30",
  },
  {
    id: "2004",
    title: "破晓时分",
    category: "tv",
    genres: ["谍战", "悬疑"],
    year: 2023,
    region: "中国大陆",
    rating: 8.9,
    popularity: 980000,
    director: "沈墨",
    actors: ["黎战", "苏晴", "白扬"],
    summary:
      "1940 年代的上海滩，潜伏在敌人内部的地下工作者，在危机四伏中一次次送出关键情报，用无名之躯迎接黎明。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20spy%20drama%20series%20poster%20of%20a%20man%20in%20a%20fedora%20and%20coat%20in%20a%20dim%20old%20Shanghai%20alley%2C%20deep%20red%20and%20sepia%20tones%2C%20suspenseful%20mood%2C%20high%20detail&width=600&height=900&seq=rhtv-poster-2004&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Widescreen%20rainy%20old%20Shanghai%20street%20at%20night%20during%20war%20era%2C%20moody%20cinematic%20suspense%2C%20deep%20red%20and%20sepia%20tones%2C%20high%20detail&width=1600&height=900&seq=rhtv-backdrop-2004&orientation=landscape",
    featured: false,
    createdAt: "2023-10-19",
  },
  {
    id: "2005",
    title: "星河边境",
    category: "tv",
    genres: ["科幻", "冒险"],
    year: 2024,
    region: "美国",
    rating: 8.7,
    popularity: 1030000,
    director: "Daniel Frost",
    actors: ["Chris Hale", "Ivy Chen", "Omar Zane"],
    summary:
      "人类边境殖民地的补给飞船失联，一支临时拼凑的探险队深入未知星域，在那里，他们发现了一个足以改变人类未来的秘密。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20space%20series%20poster%20of%20a%20crew%20silhouette%20facing%20a%20ringed%20planet%20with%20a%20red%20sunrise%2C%20deep%20red%20and%20gold%20tones%2C%20epic%20mood%2C%20high%20detail&width=600&height=900&seq=rhtv-poster-2005&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Widescreen%20space%20scene%20of%20a%20ringed%20planet%20against%20a%20deep%20red%20nebula%20with%20a%20small%20fleet%2C%20cinematic%20sci-fi%20mood%2C%20high%20detail&width=1600&height=900&seq=rhtv-backdrop-2005&orientation=landscape",
    featured: false,
    createdAt: "2024-08-08",
  },
  {
    id: "2006",
    title: "人间烟火色",
    category: "tv",
    genres: ["家庭", "都市"],
    year: 2022,
    region: "中国大陆",
    rating: 8.4,
    popularity: 860000,
    director: "何清筑",
    actors: ["林阿婆", "周晓棠", "沈航"],
    summary:
      "一家三代同堂的早餐铺，从凌晨的揉面声开始，讲述着最普通却最动人的家庭故事，烟火气里藏着最真实的爱。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20family%20series%20poster%20of%20a%20steaming%20breakfast%20shop%20before%20dawn%20with%20warm%20lamplight%2C%20warm%20red%20and%20amber%20tones%2C%20heartwarming%20mood%2C%20high%20detail&width=600&height=900&seq=rhtv-poster-2006&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Widescreen%20cozy%20neighborhood%20breakfast%20street%20in%20early%20morning%20light%2C%20warm%20cinematic%20mood%2C%20red%20and%20amber%20tones%2C%20high%20detail&width=1600&height=900&seq=rhtv-backdrop-2006&orientation=landscape",
    featured: false,
    createdAt: "2022-05-26",
  },
  {
    id: "3001",
    title: "一起去远方",
    category: "variety",
    genres: ["旅行", "真人秀"],
    year: 2024,
    region: "中国大陆",
    rating: 8.6,
    popularity: 920000,
    director: "综合作团队",
    actors: ["顾南", "宋小满", "阿凯", "柔柔"],
    summary:
      "五位性格迥异的艺人放下工作，用三十天走遍祖国最壮美的山河，在真实旅途的摩擦与感动中，重新认识彼此也认识自己。",
    poster:
      "https://readdy.ai/api/search-image?query=Vibrant%20travel%20variety%20show%20poster%20of%20a%20group%20of%20friends%20on%20a%20mountain%20summit%20at%20sunrise%2C%20warm%20orange%20and%20red%20tones%2C%20joyful%20energetic%20mood%2C%20high%20detail&width=600&height=900&seq=rhtv-poster-3001&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Widescreen%20epic%20mountain%20landscape%20at%20sunrise%20with%20a%20group%20of%20travelers%20on%20a%20ridge%2C%20warm%20orange%20and%20crimson%20tones%2C%20adventurous%20cinematic%20mood%2C%20high%20detail&width=1600&height=900&seq=rhtv-backdrop-3001&orientation=landscape",
    featured: false,
    createdAt: "2024-07-05",
  },
  {
    id: "3002",
    title: "舌尖的四季",
    category: "variety",
    genres: ["美食", "纪录片"],
    year: 2023,
    region: "中国大陆",
    rating: 9.2,
    popularity: 1080000,
    director: "食光工作室",
    actors: ["解说·陈禾"],
    summary:
      "跟随二十四节气走遍大江南北，探寻中国人餐桌上最应季的味道，讲述食物与土地、家族与传承之间的动人故事。",
    poster:
      "https://readdy.ai/api/search-image?query=Warm%20food%20documentary%20poster%20of%20steaming%20seasonal%20dishes%20on%20a%20rustic%20table%2C%20warm%20red%20and%20amber%20tones%2C%20appetizing%20mood%2C%20high%20detail&width=600&height=900&seq=rhtv-poster-3002&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Widescreen%20rustic%20Chinese%20kitchen%20scene%20with%20fresh%20seasonal%20ingredients%20in%20warm%20light%2C%20appetizing%20cinematic%20mood%2C%20red%20and%20amber%20tones%2C%20high%20detail&width=1600&height=900&seq=rhtv-backdrop-3002&orientation=landscape",
    featured: false,
    createdAt: "2023-03-10",
  },
  {
    id: "3003",
    title: "声临其境夜",
    category: "variety",
    genres: ["音乐", "竞技"],
    year: 2024,
    region: "中国大陆",
    rating: 8.3,
    popularity: 780000,
    director: "夜声导演组",
    actors: ["导师团", "林音", "祁航"],
    summary:
      "实力歌手与新声力量同台竞演，用一场场震撼的现场演绎，重现华语乐坛的经典时刻，也为原创音乐提供最亮的舞台。",
    poster:
      "https://readdy.ai/api/search-image?query=Music%20competition%20show%20poster%20of%20a%20singer%20silhouette%20under%20a%20single%20red%20spotlight%20on%20stage%2C%20deep%20red%20and%20black%20tones%2C%20dramatic%20mood%2C%20high%20detail&width=600&height=900&seq=rhtv-poster-3003&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Widescreen%20dramatic%20concert%20stage%20with%20red%20spotlights%20and%20haze%20over%20an%20excited%20crowd%2C%20cinematic%20energetic%20mood%2C%20high%20detail&width=1600&height=900&seq=rhtv-backdrop-3003&orientation=landscape",
    featured: false,
    createdAt: "2024-04-18",
  },
  {
    id: "3004",
    title: "脑力大作战",
    category: "variety",
    genres: ["竞技", "真人秀"],
    year: 2024,
    region: "中国大陆",
    rating: 8.1,
    popularity: 640000,
    director: "极智团队",
    actors: ["主持人·方野", "选手团"],
    summary:
      "来自各行各业的脑力高手同场竞技，在推理、记忆与逻辑的极限挑战中，角逐年度最强大脑的称号。",
    poster:
      "https://readdy.ai/api/search-image?query=Game%20show%20poster%20of%20glowing%20geometric%20puzzle%20patterns%20on%20a%20dark%20stage%20with%20red%20accents%2C%20futuristic%20mood%2C%20high%20detail&width=600&height=900&seq=rhtv-poster-3004&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Widescreen%20futuristic%20quiz%20show%20stage%20with%20glowing%20red%20geometric%20lights%2C%20cinematic%20energetic%20mood%2C%20high%20detail&width=1600&height=900&seq=rhtv-backdrop-3004&orientation=landscape",
    featured: false,
    createdAt: "2024-02-29",
  },
  {
    id: "3005",
    title: "喜剧奇妙夜",
    category: "variety",
    genres: ["脱口秀", "喜剧"],
    year: 2023,
    region: "中国大陆",
    rating: 8.5,
    popularity: 830000,
    director: "笑点工厂",
    actors: ["喜剧天团", "阿豆", "老白"],
    summary:
      "一群年轻的喜剧人用最犀利又最温柔的视角，讲述生活里的荒诞与温暖，在笑声中和观众一起治愈疲惫的夜晚。",
    poster:
      "https://readdy.ai/api/search-image?query=Comedy%20show%20poster%20of%20a%20retro%20microphone%20on%20a%20stage%20with%20warm%20spotlight%2C%20warm%20red%20and%20cream%20tones%2C%20playful%20mood%2C%20high%20detail&width=600&height=900&seq=rhtv-poster-3005&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Widescreen%20cozy%20comedy%20club%20stage%20with%20warm%20red%20spotlight%20and%20seats%2C%20cheerful%20cinematic%20mood%2C%20high%20detail&width=1600&height=900&seq=rhtv-backdrop-3005&orientation=landscape",
    featured: false,
    createdAt: "2023-11-12",
  },
];